export default {
  'manualPush.pushName': '消息名称',
  'manualPush.status': '状态',
  'manualPush.pushTime': '发送时间',
  'manualPush.createUserName': '操作人',
  'manualPush.createTime': '操作时间',
  'manualPush.opt': '操作',
  'manualPush.status.standby': '待发送',
  'manualPush.status.sending': '发送中',
  'manualPush.status.send': '已发送',
  'manualPush.detail': '详情',
  'manualPush.add': '实时推送',
  'manualPush.modalTitle.create': '新增实时推送',
  'manualPush.selectMember': '选择会员',
  'manualPush.allMembers': '全部会员',
  'manualPush.partialMembers': '会员',
  'manualPush.agent': '代理',
  'manualPush.memberImport': '文档导入',
  'manualPush.member': '会员',
  'manualPush.selectLanguage': '选择语言',
  'manualPush.languagePlaceholder': '请选择',
  'manualPush.pleaseSelectLanguage': '请选择语言',
  'manualPush.sendTitle': '发送标题',
  'manualPush.pushContent': '推送内容',
  'manualPush.jumpPath': '跳转路径',
  'manualPush.siteStatus': '站内推送开关',
  'manualPush.siteStatus.open': '开启',
  'manualPush.siteStatus.close': '关闭',
  'manualPush.pleaseSelectSiteStatus': '请选择站信推送开关',
  'manualPush.siteType': '站内消息类型',
  'manualPush.pleaseSelectSiteType': '请选择站内消息类型',
  'manualPush.siteType.system': '系统消息',
  'manualPush.siteType.promos': '优惠分类消息',
  'manualPush.siteType.platform': '平台消息',
  'manualPush.pleaseInputPushName': '请输入消息名称',
  'manualPush.pleaseInputSendTitle': '请输入发送标题',
  'manualPush.pleaseInputPushContent': '请输入推送内容',
  'manualPush.pleaseInputMembers': '请输入会员账号',
  'manualPush.pleaseEnter': '请输入',
  'manualPush.max50Characters': '50个字符以内',
  'manualPush.max500Characters': '500个字符以内',
  'manualPush.enterMemberAccounts': '请输入会员账号，多个账号用逗号分隔',
  'manualPush.enterAgentAccounts': '请输入代理账号，多个账号用逗号分隔',
  'manualPush.pleaseInputAgents': '请输入代理账号',
  'manualPush.excelFile': 'Excel文件',
  'manualPush.pleaseUploadExcelFile': '请上传Excel文件',
  'manualPush.fileSizeLimit': '文件大小不能超过10MB',
  'manualPush.clickToUpload': '点击上传',
  'manualPush.excelFileFormat': '支持 .xlsx 和 .xls 格式',
  'manualPush.createSuccess': '创建成功',
  'manualPush.createFailed': '创建失败',
  'manualPush.formValidationFailed': '表单验证失败',
  'manualPush.downloadSample': '下载范例',
  'manualPush.sampleFileDownloaded': '范例文件已下载',
  'manualPush.uploadInstructions': '上传说明',
  'manualPush.instruction1': 'Excel文件第二列开始应为会员账号',
  'manualPush.instruction2': '文件大小不能超过10MB',
  'manualPush.instruction3': '支持.xlsx和.xls格式',
  'manualPush.membersList': '推送会员',
  'manualPush.membersCount': '个会员',
  'manualPush.reportDetail': '推送报告详情',
  'manualPush.pushStatus': '推送状态',
  'manualPush.pushStatus.success': '推送成功',
  'manualPush.pushStatus.failed': '推送失败',
  'manualPush.pushStatus.pending': '待推送',
  'manualPush.failureReason': '失败原因',
  'manualPush.date': '日期',
  'manualPush.operator': '操作人',
  'manualPush.sendUserCount': '发送用户量',
  'manualPush.pushSuccessToFailed': '推送总量/到达量',
  'manualPush.pushOpenCount': '推送打开量',
  'manualPush.siteMessageSwitch': '站内信消息开关',
  'manualPush.memberType': '会员类型',
  'manualPush.memberType.specify': '指定会员',
  'manualPush.memberType.agent': '代理',
  'manualPush.memberType.import': '文档导入',
  'manualPush.memberType.all': '全部会员',
  'manualPush.pushOpenRate': '推送打开率',
};
